import { Component, Input, OnInit } from '@angular/core';
import { Cutting } from 'src/app/models/configurators-2d/applications/workbench/cutting';
import { WorkbenchService } from 'src/app/services/configurators-2d/applications/workbench.service';
import { Configurators2DComponent } from '../../../configurators-2d.component';
import { IWorkbenchPreview } from '../../preview/i-workbench-preview';
import { ConfigurationPlan } from 'src/app/models/configurators-2d/applications/workbench/configurations/configuration-plan';
import { WorkbenchConfiguratorItem } from '../../../configurator/applications/workbench-configurator-item';
import { ConfigurationCutting } from 'src/app/models/configurators-2d/applications/workbench/configurations/configuration-cutting';
import { Point } from 'src/app/models/configurators-2d/applications/workbench/utils/point';

@Component({
  selector: 'ng-workbench-splashback-cutting-infos',
  templateUrl: './splashback-cutting-infos.component.html',
})
export class WorkbenchSplashbackCuttingInfosComponent extends WorkbenchConfiguratorItem implements OnInit {
  @Input() cuttings: Cutting[];

  selectedCutting: Cutting;

  index: number;
  plans: ConfigurationPlan[];
  selectedPlanIndex: number;
  selectedSplashbackIndex: number;
  selectedSplashbackCuttingIndex: number;

  preview: IWorkbenchPreview;

  constructor(
    public workbenchService: WorkbenchService,
    configurator2DComponent: Configurators2DComponent
  ) {
    super(workbenchService);
    this.preview = configurator2DComponent.preview as IWorkbenchPreview;
  }

  ngOnInit(): void {
    this.plans = this.configuration.workbenchConfigurationPlans;
  }

  /**
   * Ajout d'une ouverture à la crédence sélectionnée.
   */
  addSplashbackConfigurationCutting(index: number) {
    const plan = this.configuration.workbenchConfigurationPlans.find(p => p.displayOrder === this.selectedPlanIndex);
    const splashback = plan.configurationSplashbacks.find(s => s.displayOrder === index);

    if (!splashback.configurationCuttings) {
      splashback.configurationCuttings = [];
    }

    const displayOrder = splashback.configurationCuttings.length + 1;
    splashback.configurationCuttings.push(new ConfigurationCutting(displayOrder));
    // Ouvre automatiquement la nouvelle ouverture
    this.selectedSplashbackCuttingIndex = displayOrder;
  }

  /**
   * Sélection du type de découpe pour l'ouverture en cours.
   */
  selectCutting(cutting: Cutting, splashbackDisplayOrder: number): void {
    const plan = this.configuration.workbenchConfigurationPlans.find(p => p.displayOrder === this.selectedPlanIndex);
    const splashback = plan.configurationSplashbacks.find(s => s.displayOrder === splashbackDisplayOrder);
    const splashbackCutting = splashback.configurationCuttings.find(
      c => c.displayOrder === this.selectedSplashbackCuttingIndex
    );

    splashbackCutting.cuttingId = cutting.id;
    splashbackCutting.cutting = cutting;

    // Origine par défaut au centre de la crédence (sera affinée côté backend si besoin)
    if (!splashbackCutting.origin) {
      splashbackCutting.origin = new Point(
        Math.round(splashback.length / 2),
        Math.round(splashback.height / 2)
      );
    }

    this.selectedCutting = cutting;
    this.preview.recreateSplashbacks?.();
  }

  /**
   * Suppression d'une ouverture.
   */
  deleteCutting(splashbackDisplayOrder: number, index: number): void {
    const plan = this.configuration.workbenchConfigurationPlans.find(p => p.displayOrder === this.selectedPlanIndex);
    const splashback = plan.configurationSplashbacks.find(s => s.displayOrder === splashbackDisplayOrder);

    splashback.configurationCuttings.splice(
      splashback.configurationCuttings.findIndex(c => c.displayOrder === index + 1),
      1
    );
    // Ré-indexage
    splashback.configurationCuttings.forEach((c, i) => (c.displayOrder = i + 1));

    if (this.selectedSplashbackCuttingIndex === index + 1) {
      this.selectedSplashbackCuttingIndex = null;
    }

    this.preview.recreateSplashbacks?.();
  }

  /**
   * Indique si le type de découpe est sélectionné pour l'ouverture en cours.
   */
  isCuttingSelected(splashbackDisplayOrder: number, cuttingId: number): boolean {
    const plan = this.configuration.workbenchConfigurationPlans.find(p => p.displayOrder === this.selectedPlanIndex);
    const splashback = plan?.configurationSplashbacks.find(s => s.displayOrder === splashbackDisplayOrder);
    const cc = splashback?.configurationCuttings.find(c => c.displayOrder === this.selectedSplashbackCuttingIndex);
    return cc?.cuttingId === cuttingId;
  }

  toggleCuttingCollapse(displayOrder: number): void {
    this.selectedSplashbackCuttingIndex = this.selectedSplashbackCuttingIndex === displayOrder ? null : displayOrder;
  }

  togglePlanCollapse(displayOrder: number): void {
    this.selectedPlanIndex = this.selectedPlanIndex === displayOrder ? null : displayOrder;
    this.selectedSplashbackIndex = null;
    this.selectedSplashbackCuttingIndex = null;
  }

  toggleSplashbackCollapse(displayOrder: number): void {
    this.selectedSplashbackIndex = this.selectedSplashbackIndex === displayOrder ? null : displayOrder;
    this.selectedSplashbackCuttingIndex = null;
  }
}
